import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "hidden sm:block" }
const _hoisted_2 = {
  autocomplete: "off",
  class: "flex flex-col gap-3"
}
const _hoisted_3 = { class: "grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-6" }
const _hoisted_4 = { class: "sm:col-span-4" }
const _hoisted_5 = { class: "block text-sm font-medium text-gray-800" }
const _hoisted_6 = { class: "grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-6" }
const _hoisted_7 = { class: "sm:col-span-4" }
const _hoisted_8 = { class: "block text-sm font-medium text-gray-800" }
const _hoisted_9 = { class: "grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-6" }
const _hoisted_10 = { class: "sm:col-span-4" }
const _hoisted_11 = { class: "block text-sm font-medium text-gray-800" }
const _hoisted_12 = { class: "mt-4 grid grid-cols-2 place-content-around gap-4 text-center" }

import { ref, Ref, computed, watch, onMounted, nextTick } from 'vue';
import store from '@/store';
import { useI18n } from 'vue-i18n';
import {
    MultiSelectOption,
    NumberActions,
    NumberFilter,
    NumberGetters,
    SelectOptionsServiceGetCitiesResult,
} from '@/types';
import { FilterIcon } from '@heroicons/vue/solid';
import { toastServiceError } from '@/services/core/notification';
import SelectOptionsService from '@/services/api/SelectOptionsService';


export default /*@__PURE__*/_defineComponent({
  __name: 'NumberListFilters',
  setup(__props) {

const { t } = useI18n();

const filtersOpened = ref(false);
const suppressCityReset = ref(false);

const storeFilter = computed(() => store.getters[NumberGetters.FILTER]);
const defaultFilter = computed(() => store.getters[NumberGetters.DEFAULT_FILTER]);

const filter: Ref<NumberFilter> = ref({
    hasConnectFlow: defaultFilter.value.hasConnectFlow,
    state: null,
    city: null,
});

const hasConnectFlowFilterOptions: Ref<MultiSelectOption[]> = ref([
    {
        label: t('number.filters.hasConnectFlow.options.yes'),
        value: true,
    } as MultiSelectOption,
    {
        label: t('number.filters.hasConnectFlow.options.no'),
        value: false,
    } as MultiSelectOption,
]);

const cities: Ref<SelectOptionsServiceGetCitiesResult[]> = ref([]);
const getCities = async () => {
    try {
        const response = await SelectOptionsService.getCities();
        cities.value = response.data;
    } catch (error) {
        toastServiceError(error);
    }
};

const stateOptions = computed(() =>
    [...new Set(cities.value.map((c) => c.state))].sort().map((state) => ({
        state,
    })),
);
const cityOptions = computed(() =>
    filter.value.state ? cities.value.filter((c) => c.state === filter.value.state) : cities.value,
);

function applyFilters() {
    store.dispatch(NumberActions.SET_FILTER, filter.value);
}

function clearFilters() {
    store.dispatch(NumberActions.CLEAR_FILTER);
    refreshLocalFilter();
}

function refreshLocalFilter() {
    suppressCityReset.value = true;
    filter.value.hasConnectFlow = storeFilter.value.hasConnectFlow;
    filter.value.state = storeFilter.value.state;
    filter.value.city = storeFilter.value.city;
    nextTick(() => {
        suppressCityReset.value = false;
    });
}

watch(
    () => filter.value.state ?? null,
    (nv, ov) => {
        if (nv !== ov && !suppressCityReset.value) {
            filter.value.city = null;
        }
    },
);

watch(filtersOpened, () => {
    if (filtersOpened.value) refreshLocalFilter();
});

onMounted(() => {
    getCities();
});

return (_ctx: any,_cache: any) => {
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiMultiselect = _resolveComponent("UiMultiselect")!
  const _component_UiRightPanel = _resolveComponent("UiRightPanel")!

  return (_openBlock(), _createBlock(_component_UiRightPanel, {
    modelValue: filtersOpened.value,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filtersOpened).value = $event)),
    title: _ctx.$t('filter.sidebar.title')
  }, {
    button: _withCtx(() => [
      _createVNode(_component_UiButton, {
        size: "md",
        variant: "white",
        "text-variant": "gray-700",
        class: "hover:bg-gray-50",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (filtersOpened.value = true))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(FilterIcon), {
            class: "mr-0 h-5 w-5 text-gray-400 sm:mr-3",
            "aria-hidden": "true"
          }),
          _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('core.actions.Filter')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('number.filters.hasConnectFlow.label')), 1),
            _createVNode(_component_UiMultiselect, {
              name: "filters_hasConnectFlow",
              modelValue: filter.value.hasConnectFlow,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filter.value.hasConnectFlow) = $event)),
              options: hasConnectFlowFilterOptions.value,
              "can-clear": "",
              placeholder: _unref(t)('core.options.All')
            }, null, 8, ["modelValue", "options", "placeholder"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('number.filters.state.label')), 1),
            _createVNode(_component_UiMultiselect, {
              name: "filters_state",
              modelValue: filter.value.state,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filter.value.state) = $event)),
              options: stateOptions.value,
              label: "state",
              "value-prop": "state",
              "can-clear": "",
              primitive: "",
              placeholder: _unref(t)('core.options.All')
            }, null, 8, ["modelValue", "options", "placeholder"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('number.filters.city.label')), 1),
            _createVNode(_component_UiMultiselect, {
              name: "filters_city",
              modelValue: filter.value.city,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filter.value.city) = $event)),
              options: cityOptions.value,
              label: "city",
              "value-prop": "city",
              "can-clear": "",
              primitive: "",
              placeholder: _unref(t)('core.options.All')
            }, null, 8, ["modelValue", "options", "placeholder"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_UiButton, {
            variant: "white",
            "text-variant": "gray-700",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (clearFilters()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Clear')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_UiButton, {
            variant: "primary",
            "text-variant": "white",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (applyFilters()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Apply')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})